export type StackedBarChartPlotBounds = {
  left: number;
  top: number;
  width: number;
  height: number;
};

type BuildEstimatedStackedBarChartPlotBoundsParams = {
  adjustedMarginLeft: number;
  containerWidth: number | null;
  height: number;
  marginBottom: number;
  marginRight: number;
  marginTop: number;
  resolvedYAxisWidth: number;
};

export const buildEstimatedStackedBarChartPlotBounds = ({
  adjustedMarginLeft,
  containerWidth,
  height,
  marginBottom,
  marginRight,
  marginTop,
  resolvedYAxisWidth,
}: BuildEstimatedStackedBarChartPlotBoundsParams): StackedBarChartPlotBounds | null => {
  if (containerWidth === null) return null;
  const left = Math.max(0, adjustedMarginLeft + resolvedYAxisWidth);
  return {
    left,
    top: marginTop,
    width: Math.max(0, containerWidth - left - marginRight),
    height: Math.max(0, height - marginTop - marginBottom),
  };
};
